import { Stack, styled } from '@mui/material';

export const StackScroll = styled(Stack)`
  overflow: auto;

  ::-webkit-scrollbar {
    width: 8px;
    border-radius: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #e6e6e6;
    border-radius: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.palette['Ambient/Grayscale/Gray-100']};
    height: 40px;
    border-radius: 8px;
  }

  /* ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.palette['Ambient/Grayscale/Gray-100']};
  } */
`;
